(function () {
  // Expose initializer globally so views can call it with specific field IDs.
  function toTitleCaseNoSpaces(value) {
    return (value || '')
      .trim()
      // split on whitespace or common separators or any non-alphanumeric
      .split(/[^A-Za-z0-9]+/)
      .filter(function (w) { return w.length > 0; })
      .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); })
      .join('');
  }

  function initAutoGenerateTechnicalName(displayId, nameId) {
    if (!displayId || !nameId) return;

    function attach() {
      var displayEl = document.getElementById(displayId);
      var nameEl = document.getElementById(nameId);
      if (!displayEl || !nameEl) return;
      if (nameEl.dataset.techNameInitialized === 'true') return;

      nameEl.dataset.techNameInitialized = 'true';

      // Track whether the user has entered a non-empty value in the Name field.
      var userEdited = nameEl.value.trim() !== '';
      // Set while we synthesize input/change events on the name field so we can
      // distinguish programmatic updates from real user typing.
      var suppressUserEditedTracking = false;

      // Resume auto-generation only when the Name field is empty again.
      nameEl.addEventListener('input', function (e) {
        if (suppressUserEditedTracking || (e && e.isTrusted === false)) {
          return;
        }

        userEdited = nameEl.value.trim() !== '';
      });

      function updateGeneratedValue() {
        if (userEdited) return;

        var generated = toTitleCaseNoSpaces(displayEl.value || '');

        if (nameEl.value === generated) {
          return;
        }

        suppressUserEditedTracking = true;
        try {
          nameEl.value = generated;
          nameEl.dispatchEvent(new Event('input', { bubbles: true }));
          nameEl.dispatchEvent(new Event('change', { bubbles: true }));
        } finally {
          suppressUserEditedTracking = false;
        }
      }

      displayEl.addEventListener('input', updateGeneratedValue);
      displayEl.addEventListener('keyup', updateGeneratedValue);
      displayEl.addEventListener('change', updateGeneratedValue);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attach);
    } else {
      attach();
    }
  }

  // Automatically initialize for any elements using the data attributes.
  document.addEventListener('DOMContentLoaded', function () {
    var autoEls = document.querySelectorAll('[data-auto-tech-name]');
    for (var i = 0; i < autoEls.length; i++) {
      var el = autoEls[i];
      var displayId = el.getAttribute('data-display-id');
      var nameId = el.getAttribute('data-name-id');
      if (displayId && nameId) {
        // call initializer immediately (it will attach listeners)
        initAutoGenerateTechnicalName(displayId, nameId);
      }
    }
  });

  window.initAutoGenerateTechnicalName = initAutoGenerateTechnicalName;
})();
